<template>
  <div class="Info">
    <div class="title">{{title}}</div>
    <div class="panel">
      <p>
        当前时间不可报名和参赛，初赛报名参赛时间如下：
      </p>
      <p>
       2025.09.15-2025.11.30
      </p>
    </div>
  </div>
</template>

<script>
 import MyButton from '@/components/Button.vue'
 export default {
   name: 'Info',
   data () {
     return {
       tips: false,
       tip: '请先登录你的账号',
     }
   },
   methods: {
   },
   computed: {
     title() {
       return '提示'
     },
   },
   components:{
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Info{
   box-sizing: border-box;
   border-radius: 1vw;

   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: space-between;
 }
 .title{
   font-size: 1.875vw;
   line-height: 6.85vw;
   display: flex;
   align-items:center;
   justify-content: center;

   width: 100%;
 }
 .panel{
   width: 100%;
   display: flex;
   align-items: center;
   justify-content:space-between;
   flex-direction: column;
   font-size: 18px;
 }

 .notice{
   color: white;
   line-height: 1.5625vw;
   width: 88%;
   margin-top: 2vw;
 }
 .button{
   width: 7.6vw;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   position: relative;
   margin: 2vw 0;
 }

 .item{
   white-space: pre-line;
 }
 .tips{
   color: #FF3D2E;
   font-size: 0.9375vw;
   display: flex;
   background-image: url(~@/assets/image/enroll/bg-tips.png);
   background-size: 10.1vw;
   position: absolute;
   top: -2.2vw;
   height: 1.92vw;
   width: 9.1vw;
   align-items:center;
   justify-content:center;
 }
 .tips.user{
   opacity: 0;
 }
 .tips.success{
   opacity: 1 !important;
   color: var(--blue);
 }
</style>
